import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as moment from "moment";

@Component({
    selector: 'app-coupon-form-3',
    templateUrl: './coupon-form-3.component.html',
    styleUrls: ['./coupon-form-3.component.css']
  })
  export class CouponFormComponent3 {
    form: FormGroup;
  datesError = false;
  @Input() coupon: any;
  @Output() couponSaved: EventEmitter<any> = new EventEmitter();
  

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    console.log("coupon dentro edit", this.coupon);

    // Converte le date string in oggetti Date usando Moment.js e specifica il formato della data
    const emissionStartDate = this.coupon.emission_date_start ? moment(this.coupon.emission_date_start, 'YYYY-MM-DD').toDate() : null;
    const emissionEndDate = this.coupon.emission_date_end ? moment(this.coupon.emission_date_end, 'YYYY-MM-DD').toDate() : null;
    const fruitionStartDate = this.coupon.fruition_date_start ? moment(this.coupon.fruition_date_start, 'YYYY-MM-DD').toDate() : null;
    const fruitionEndDate = this.coupon.fruition_date_end ? moment(this.coupon.fruition_date_end, 'YYYY-MM-DD').toDate() : null;

    this.form = this.fb.group({
        emissionDateStart: [emissionStartDate],
        emissionDateEnd: [emissionEndDate],
        fruitionDateStart: [fruitionStartDate],
        fruitionDateEnd: [fruitionEndDate],
    });
}

  save() {
    const emissionStart = this.form.get('emissionDateStart').value;
    const emissionEnd = this.form.get('emissionDateEnd').value;
    const fruitionStart = this.form.get('fruitionDateStart').value;
    const fruitionEnd = this.form.get('fruitionDateEnd').value;

    // Validazioni sulle date
    if (emissionEnd && emissionStart && emissionEnd < emissionStart) {
      this.datesError = true;
      console.error('Errore: emission end date non può essere inferiore a emission start date.');
      return;
    }

    if (fruitionEnd && fruitionStart && fruitionEnd < fruitionStart) {
      this.datesError = true;
      console.error('Errore: fruition end date non può essere inferiore a fruition start date.');
      return;
    }

    // Se tutte le validazioni passano, salva i dati
    const newCouponData = {
      ...this.coupon,
      emission_date_start: emissionStart ? moment(emissionStart).format('YYYY-MM-DD') : null,
      emission_date_end: emissionEnd ? moment(emissionEnd).format('YYYY-MM-DD') : null,
      fruition_date_start: fruitionStart ? moment(fruitionStart).format('YYYY-MM-DD') : null,
      fruition_date_end: fruitionEnd ? moment(fruitionEnd).format('YYYY-MM-DD') : null
    };

    this.datesError = false; // Reset del flag di errore
    this.couponSaved.emit(newCouponData);
  }


  
  }


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/coupon-form-3/coupon-form-3.component.ts